import React from 'react';
import { Image } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').Image}
 */
const ImageBlock = ({
    image,
    video,
    caption
}) => {
    // render
    return (
        <>
            <div className='col-12'>
                <figure>
                    <div>
                        {video ? (
                            <video
                                autoPlay
                                loop
                                muted
                                playsInline
                                src={video.videoUrl}/>
                        ) : (
                            <Image {...image} />
                        )}
                    </div>
                </figure>
            </div>
            {caption &&
                <figcaption className='col-12 md-col-8 mt4'>
                    <div
                        className='rich-text type-style-7'
                        dangerouslySetInnerHTML={{__html: caption}} />
                </figcaption>
            }
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ImageBlock;
